module.exports = __webpack_public_path__ + "static/media/realtalk_sd_theater_groupej4a765ebb668019585b66a7f17a4b3561.webp";